import React, { useState, useContext, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faInfoCircle,
  faGift,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons'

import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import styled from 'styled-components'
import PointsModal from './PointsModal'
import RedeemModal from './RedeemModal'
import { JazeelContext } from '../../../utils/JazeelContext'
import CampaignButton from 'components/ActiveButton'

const PointsContainer = styled(Card)`
  text-align: center;
  display: flex;
  background: white;
  border: none;
  //border-radius: 10px 0 0 10px;
  box-shadow: -6px 1px 15px 4px rgba(0, 0, 0, 0.05);

  //@media screen and (max-width: 768px) {
  //  border-radius: 10px;
  //}
`
const PointsNumber = styled.h1`
  color: #212529;
  font-size: 4.063em;
  font-weight: bold;
  line-height: 1em;
  text-align: center;
`
const Title = styled(Card.Title)`
  color: #212529;
  font-size: 0.875em;
  line-height: 1.125em;
  text-align: center;
`
const PointsText = styled(Card.Text)`
  color: #212529;
  font-size: 1.125em;
  font-weight: bold;
  line-height: 1.375em;
  text-align: center;
`
const ExpirationText = styled.p`
  color: #777777;
  font-size: 0.75em;
  line-height: 0.938em;
  text-align: center;
  padding-top: 1.125em;
`
const RedeemLink = styled.a`
  color: #65d28e;
  font-size: 0.83em;
  display: block;
`

export default function PointsCard() {
  const { userData, isMobile } = useContext(JazeelContext)
  const [modalShow, setModalShow] = useState(false)
  const [redeemShow, setRedeemShow] = useState(false)
  const handleShow = () => setModalShow(true)
  const handleHide = () => setModalShow(false)
  const handleRedeemShow = () => setRedeemShow(true)
  const handleRedeemHide = () => setRedeemShow(false)
  return (
    <Fragment>
      <Col lg={4} className="mb-3">
        <PointsContainer className="h-100">
          <div className="text-right pr-3 pt-3">
            <FontAwesomeIcon icon={faEllipsisH} color="lightgrey" />
          </div>
          <Card.Body className="align-self-center justify-content-center p-0 pb-3">
            <Title>Total Earned Point</Title>
            <PointsNumber className="text-warning">
              {userData && userData.earned_point}
            </PointsNumber>
            <PointsText>Points</PointsText>
            {/*<ExpirationText>*/}
            {/*  <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />*/}
            {/*  Expires in 21 Nov 2020*/}
            {/*</ExpirationText>*/}
            {/*<CampaignButton*/}
            {/*  text="Get More Points"*/}
            {/*  background="linear-gradient(45deg, #11BED3 0%, #9CDF61 100%)"*/}
            {/*  borderRadius="10px"*/}
            {/*  textColor="#ffffff"*/}
            {/*  textSize="0.8em"*/}
            {/*  width={isMobile ? '18em' : '100%'}*/}
            {/*  height="3em"*/}
            {/*  handleSubmit={handleShow}*/}
            {/*/>*/}
            {/*<EarnPointsButton*/}
            {/*  onClick={handleShow}*/}
            {/*  className="btn-reward btn-sm mt-2"*/}
            {/*>*/}
            {/*  Earn More Points*/}
            {/*</EarnPointsButton>*/}
            {/*<PointsModal show={modalShow} onHide={handleHide} />*/}
            {/*<RedeemLink*/}
            {/*  href="#"*/}
            {/*  onClick={handleRedeemShow}*/}
            {/*  className="small mt-1"*/}
            {/*>*/}
            {/*  <FontAwesomeIcon icon={faGift} /> Redeem Points*/}
            {/*</RedeemLink>*/}
            {/*<RedeemModal show={redeemShow} onHide={handleRedeemHide} />*/}
          </Card.Body>
        </PointsContainer>
      </Col>
      <Col lg={4} className="mb-3">
        <PointsContainer className="h-100">
          <div className="text-right pr-3 pt-3">
            <FontAwesomeIcon icon={faEllipsisH} color="lightgrey" />
          </div>
          <Card.Body className="align-self-center justify-content-center p-0 pb-3">
            <Title>Current Point</Title>
            <PointsNumber className="text-success">
              {userData && userData.current_point}
            </PointsNumber>
            <PointsText>Points</PointsText>
            {/*<ExpirationText>*/}
            {/*  <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />*/}
            {/*  Expires in 21 Nov 2020*/}
            {/*</ExpirationText>*/}
            {/*<CampaignButton*/}
            {/*  text="Get More Points"*/}
            {/*  background="linear-gradient(45deg, #11BED3 0%, #9CDF61 100%)"*/}
            {/*  borderRadius="10px"*/}
            {/*  textColor="#ffffff"*/}
            {/*  textSize="0.8em"*/}
            {/*  width={isMobile ? '18em' : '100%'}*/}
            {/*  height="3em"*/}
            {/*  handleSubmit={handleShow}*/}
            {/*/>*/}
            {/*<EarnPointsButton*/}
            {/*  onClick={handleShow}*/}
            {/*  className="btn-reward btn-sm mt-2"*/}
            {/*>*/}
            {/*  Earn More Points*/}
            {/*</EarnPointsButton>*/}
            {/*<PointsModal show={modalShow} onHide={handleHide} />*/}
            {/*<RedeemLink*/}
            {/*  href="#"*/}
            {/*  onClick={handleRedeemShow}*/}
            {/*  className="small mt-1"*/}
            {/*>*/}
            {/*  <FontAwesomeIcon icon={faGift} /> Redeem Points*/}
            {/*</RedeemLink>*/}
            {/*<RedeemModal show={redeemShow} onHide={handleRedeemHide} />*/}
          </Card.Body>
        </PointsContainer>
      </Col>
      <Col lg={4} className="mb-3">
        <PointsContainer className="h-100">
          <div className="text-right pr-3 pt-3">
            <FontAwesomeIcon icon={faEllipsisH} color="lightgrey" />
          </div>
          <Card.Body className="align-self-center justify-content-center p-0 pb-3">
            <Title>Withdrawn Point</Title>
            <PointsNumber className="text-danger">
              {userData && userData.withdrawn_point}
            </PointsNumber>
            <PointsText>Points</PointsText>
            {/*<ExpirationText>*/}
            {/*  <FontAwesomeIcon icon={faInfoCircle} className="mr-2" />*/}
            {/*  Expires in 21 Nov 2020*/}
            {/*</ExpirationText>*/}
            {/*<CampaignButton*/}
            {/*  text="Get More Points"*/}
            {/*  background="linear-gradient(45deg, #11BED3 0%, #9CDF61 100%)"*/}
            {/*  borderRadius="10px"*/}
            {/*  textColor="#ffffff"*/}
            {/*  textSize="0.8em"*/}
            {/*  width={isMobile ? '18em' : '100%'}*/}
            {/*  height="3em"*/}
            {/*  handleSubmit={handleShow}*/}
            {/*/>*/}
            {/*<EarnPointsButton*/}
            {/*  onClick={handleShow}*/}
            {/*  className="btn-reward btn-sm mt-2"*/}
            {/*>*/}
            {/*  Earn More Points*/}
            {/*</EarnPointsButton>*/}
            {/*<PointsModal show={modalShow} onHide={handleHide} />*/}
            {/*<RedeemLink*/}
            {/*  href="#"*/}
            {/*  onClick={handleRedeemShow}*/}
            {/*  className="small mt-1"*/}
            {/*>*/}
            {/*  <FontAwesomeIcon icon={faGift} /> Redeem Points*/}
            {/*</RedeemLink>*/}
            {/*<RedeemModal show={redeemShow} onHide={handleRedeemHide} />*/}
          </Card.Body>
        </PointsContainer>
      </Col>
    </Fragment>
  )
}
